var map = {
	"./first-block.svg": "ZrbV",
	"./last-block.svg": "br7d",
	"./middle-block.svg": "GKHI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "l8+O";


//////////////////
// WEBPACK FOOTER
// ./src/assets/form-ui/summary-block ^\.\/.*\-block\.svg$
// module id = l8+O
// module chunks = 46